import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  SEARCH_GEO_COUNTRY,
  SEARCH_SUPPLIER_STATE
} from '../actions';

import {
  SearchGeoCountrySuccess,
  SearchGeoCountryError,
  SearchSupplierStateSuccess,
  SearchSupplierStateError
} from '../actions';


export function* watchSearchGeoCountry() {
  yield takeEvery(SEARCH_GEO_COUNTRY, onSearchGeoCountry);
}

export function* watchSearchSupplierState() {
  yield takeEvery(SEARCH_SUPPLIER_STATE, onSearchSupplierState);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onSearchGeoCountryAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/geo_country', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchSupplierStateAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier_state', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onSearchGeoCountry(data) {
  try {
    const response = yield call(onSearchGeoCountryAsync, data);
    yield put(SearchGeoCountrySuccess(response.data));
  } catch (error) {
    yield put(SearchGeoCountryError(error));
  }
}

function* onSearchSupplierState(data) {
  try {
    const response = yield call(onSearchSupplierStateAsync, data);
    yield put(SearchSupplierStateSuccess(response.data));
  } catch (error) {
    yield put(SearchSupplierStateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchSearchGeoCountry),
    fork(watchSearchSupplierState)
  ]);
}